<template>
    <div class="container">
        <!-- <div class="summary">
            <a-statistic
                title="当前可提现金额（元）"
                :value="data_summary.amount"
                style="margin-right: 50px"
            />

            <a-statistic
                title="处理中的提现金额（元）"
                :value="data_summary.amount_pend"
                style="margin-right: 50px"
            />

            <a-statistic
                title="累计成功提现金额（元）"
                :value="data_summary.amount_succeed"
                style="margin-right: 50px"
            />
        </div> -->
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-divider type="vertical" class="item" />

                <!-- <a-radio-group v-model="search.status" button-style="solid" @change="(e) => on_field_change(e.target.value, 'status')">
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="1">处理中</a-radio-button>
                    <a-radio-button value="2">已提现</a-radio-button>
                    <a-radio-button value="3">已失败</a-radio-button>
                </a-radio-group> -->
            </div>

            <div class="right-items">
                <!-- <a-input-search
                    placeholder="搜索单号"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />-->
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <!-- 状态 -->

                <!-- 状态 -->
                <template slot="audit_status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 1">处理中</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 2">已通过</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == 3">已拒绝</a-tag>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>
                <template slot="transaction" slot-scope="text, record">
                    <span style="color:#ff9800" v-if="record.reject_msg"
                        ><a-icon type="exclamation-circle" style="margin-right:4px;" />{{ record.reject_msg }}</span
                    >
                    <span v-else>{{ text }}</span>
                </template>
                <!-- 申请人 -->
                <template slot="user" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.user ? record.user.name : "-" }}
                        </div>
                        <div class="b">
                            {{ moment(record.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>
                <template slot="screenshot" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>
                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.auditor ? record.auditor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" @click="on_approve(record)" :disabled="!!record.paid_at">上传截图</a-button>
                    </div>
                </template>
            </a-table>
        </div>

        <modal_approve type="loan" @close="visible_approve = false" :visible="visible_approve" :record="selected_record" :callback="load" />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import modal_approve from "./modal_approve";

    export default {
        mixins: [common_pagination],
        components: { modal_approve },
        data() {
            return {
                path: "/finance/payment_refund",
                data_source: [],
                loading: false,
                selected_record: {},
                wd: null,
                search: { audit_status: "" },
                visible_approve: false,
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                    {
                        dataIndex: "audit_status",
                        width: 80,
                        title: "审批状态",
                        align: "center",
                        scopedSlots: {
                            customRender: "audit_status",
                        },
                    },
                    {
                        dataIndex: "transaction_no",
                        width: 180,
                        title: "流水号",
                        scopedSlots: {
                            customRender: "transaction",
                        },
                    },
                    {
                        dataIndex: "amount",
                        width: 120,
                        title: "退款金额/元",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "member",
                        width: 100,
                        title: "退款客户",
                        scopedSlots: {
                            customRender: "member",
                        },
                    },
                    {
                        dataIndex: "user",
                        width: 120,
                        title: "申请人",
                        scopedSlots: {
                            customRender: "user",
                        },
                    },
                    {
                        dataIndex: "executor.name",
                        width: 120,
                        title: "处理人",
                        scopedSlots: {
                            customRender: "executor",
                        },
                    },
                    {
                        dataIndex: "screenshot",
                        width: 120,
                        title: "付款截图",
                        scopedSlots: {
                            customRender: "screenshot",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                    },
                    {
                        dataIndex: "action",
                        width: 150,
                        align: "center",
                        fixed: "right",
                        title: "操作",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_finance",
                value: "payment_refund",
            });
            this.load();
            this.reset_query();

            // this.load_summary();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;

                this.wd = "wd" in query ? query["wd"] : "";
                this.search.status = Object.prototype.hasOwnProperty.call(query, "status") ? query["status"] : "";
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/payment/refund?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },

            on_approve(record) {
                this.selected_record = record;
                this.visible_approve = true;
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
    }
</style>
